import { makeAutoObservable } from "mobx";
import { DataTableStore } from "./DataTableStore";
import { onError } from "@/utils/onError";
import { FiltersStore } from "./FiltersStore";
import { SearchFilter } from "@/components/filters";
export class VehicleManufacturersStore {
    constructor(vehicleManufacturerService) {
        this.vehicleManufacturerService = vehicleManufacturerService;
        this.loading = false;
        this.initializeVehicleManufacturerFilters = () => {
            const filterItems = [
                // Search Filter
                {
                    id: "search-filter",
                    Cmp: SearchFilter,
                    props: {
                        name: "search",
                        label: "Поиск",
                        placeholder: "Поиск по названию производителя...",
                        allowClear: true,
                        showSearchIcon: true,
                        onChange: (value) => this.filtersStore.updateFilter("search", value),
                    },
                    visible: true,
                    order: 4,
                },
            ];
            this.filtersStore.setFilterItems(filterItems);
        };
        this.dataTable = new DataTableStore({
            defaultFilters: { search: "" },
            dataLoader: {
                loadData: (params) => this.loadVehicleManufacturers(params),
            },
        });
        this.filtersStore = new FiltersStore();
        this.initializeVehicleManufacturerFilters();
        makeAutoObservable(this);
    }
    setLoading(loading) {
        this.loading = loading;
    }
    async loadVehicleManufacturers(params) {
        try {
            // Получаем данные через сервис с учетом параметров
            const result = await this.vehicleManufacturerService.getVehicleManufacturersWithParams({
                page: params.page,
                pageSize: params.pageSize,
                filters: params.filters,
                sorters: params.sorters,
            });
            return {
                data: result.data,
                total: result.total,
                page: params.page,
                pageSize: params.pageSize,
            };
        }
        catch (error) {
            throw error;
        }
    }
    async deleteVehicleManufacturer(id) {
        this.setLoading(true);
        try {
            await this.vehicleManufacturerService.deleteVehicleManufacturer(id);
            await this.dataTable.refresh();
        }
        catch (error) {
            onError(error, "Error deleting vehicle manufacturer");
        }
        finally {
            this.setLoading(false);
        }
    }
}
